// Accordions -------------------------------------------------
$("body").on("click", ".accordionItemHeading", toggleItem);

function scrollToTarget(target) {
    if (!target || !target.offset) return;
    
    var megaMenuHeight = $('body .mega-menu-wrapper').length > 0 ? $('body .mega-menu-wrapper').outerHeight() : 0;
    var headerWrapperHeight = $('.header-wrapper').length > 0 ? $('.header-wrapper').outerHeight() : 0;
    var headerHeight = $('.site-header').length > 0 ? $('.site-header').outerHeight() : 0;

    $('html, body').animate({ scrollTop: target.offset().top - megaMenuHeight - headerWrapperHeight - headerHeight }, '50');
}

function toggleItem() {
    var parent = $(this).parent();
    if (!parent || !parent.length) return;
    
    var eventType = parent.find('.accordion-event').first().val() || "Event";
    var phrase = parent.find('.accordion-phrase').first().val() || "Accordion";
    var eventCategory = parent.find('.accordion-category').first().val() || "Accordions";
    var eventAction = phrase;
    var eventLabel = phrase;

    if (!parent.hasClass('accordionItem')) return;
    
    // Get accordion content safely
    var accordionContent = null;
    if (this.parentNode) {
        var contentElements = this.parentNode.getElementsByClassName("accordionItemContent");
        if (contentElements && contentElements.length > 0) {
            accordionContent = contentElements[0];
        }
    }
    
    if (parent.hasClass('close')) {
        // close all of them
        $('.accordionItem').removeClass('open');
        $('.accordionItem').addClass('close');

        scrollToTarget(parent);

        // open the clicked one
        parent.removeClass('close');
        parent.addClass('open');

        // Safely update tabIndex for links and buttons
        if (accordionContent && accordionContent.childNodes) {
            $(accordionContent.childNodes).find('a').each(function() {
                if (this) this.tabIndex = 0;
            });

            $(accordionContent.childNodes).find('button').each(function() {
                if (this) this.tabIndex = 0;
            });
        }

        eventAction = "Open " + eventAction;
        eventLabel = parent.find('.accordion-label').first().val() || eventLabel;

        if (typeof window.navigationClickAnalytics === 'function') {
            window.navigationClickAnalytics(event, eventType, eventCategory, eventAction, eventLabel);
        }
    }
    else {
        // close the clicked one
        parent.removeClass('open');
        parent.addClass('close');

        // Safely update tabIndex for links and buttons
        if (accordionContent && accordionContent.childNodes) {
            $(accordionContent.childNodes).find('a').each(function() {
                if (this) this.tabIndex = -1;
            });

            $(accordionContent.childNodes).find('button').each(function() {
                if (this) this.tabIndex = -1;
            });
        }

        eventAction = "Close " + eventAction;
        eventLabel = parent.find('.accordion-label').first().val() || eventLabel;

        if (typeof window.navigationClickAnalytics === 'function') {
            window.navigationClickAnalytics(event, eventType, eventCategory, eventAction, eventLabel);
        }
    }
}

$(function() {
    var searchInterface = $('.CoveoSearchInterface');
    var initializing = true;
    
    if (searchInterface && searchInterface.length) {
        var root = document.querySelector('#' + searchInterface[0].id);
        if (!root) return;
        
        Coveo.$$(root).on('deferredQuerySuccess', function() {
            if (initializing) {
                $('.coveo-facet-header').map(function(index, item) {
                    if (!item) return;

                    $('.CoveoFacet, .CoveoFacetRange').map(function(index, facetItem) {
                        if (facetItem) {
                            $(facetItem).addClass('close');
                        }
                    });

                    var toggleCoveoItem = function() {
                        if (!this || !this.parentNode) return;
                        
                        var $facetItem = $(this.parentNode);

                        $('.CoveoFacet, .CoveoFacetRange').map(function(index, facetItem) {
                            if (facetItem && this.parentNode && facetItem.id !== this.parentNode.id) {
                                $(facetItem).removeClass('open');
                                $(facetItem).addClass('close');
                            }
                        }.bind(this));

                        if ($facetItem.hasClass('open')) {
                            $facetItem.removeClass('open');
                            $facetItem.addClass('close');
                            return;
                        }

                        if ($facetItem.hasClass('close')) {
                            $facetItem.removeClass('close');
                            $facetItem.addClass('open');
                        }
                    };

                    $(item).on('click', toggleCoveoItem);
                });
            }

            $('body').on('click', function(event) {
                if (event && event.target && event.target.className && 
                    typeof event.target.className.indexOf === 'function' && 
                    event.target.className.indexOf('coveo-facet-header') < 0) {
                    $('.CoveoFacet, .CoveoFacetRange').map(function(index, item) {
                        if (item) {
                            $(item).removeClass('open');
                            $(item).addClass('close'); 
                        }
                    });
                }
            });

            initializing = false;
        });
    }
});